<template>
  <nav id="sidebar" class="active">
    <ul class="list-unstyled d-flex flex-column w-100 sidebar-items">
      <!-- Dashboard -->
      <li>
        <a @click.prevent="redirect('dashboard')" class="sidebar-item">
          <div class="sidebar-item-label">
            <i class="mdi sidebar-item-icon mdi-chart-arc"></i>
            <span class="sidebar-item-title">Dashboard</span>
          </div>
        </a>
      </li>

      <!-- Cotações -->
      <li v-if="$can('quotation-list')">
        <div class="sidebar-item has-subitems" :class="{ active: isQuotationsActive }">
          <div class="sidebar-item-label" @click.stop="toggleQuotations">
            <i class="mdi sidebar-item-icon mdi-buffer"></i>
            <span class="sidebar-item-title">Cotações</span>
          </div>
          <ul v-if="isQuotationsActive" class="sidebar-subitems">
            <li>
              <a @click.prevent="redirect('list-quotation')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-view-list"></i>
                  <span class="sidebar-subitem-title">Listagem de cotações</span>
                </div>
              </a>
            </li>
            <li>
              <a @click.prevent="redirect('kanban-quotation')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-file-table-box-multiple-outline"></i>
                  <span class="sidebar-subitem-title">Painel de Cotações</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!-- Apólices -->
      <li v-if="$can('policy-list')">
        <div class="sidebar-item has-subitems" :class="{ active: isPoliciesActive }">
          <div class="sidebar-item-label" @click.stop="togglePolicies">
            <i class="mdi sidebar-item-icon mdi-folder-open"></i>
            <span class="sidebar-item-title">Apólices</span>
          </div>
          <ul v-if="isPoliciesActive" class="sidebar-subitems">
            <li>
              <a @click.prevent="redirect('list-policies')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-checkbox-multiple-marked"></i>
                  <span class="sidebar-subitem-title">Apólices emitidas</span>
                </div>
              </a>
            </li>
            <li v-if="$can('claim-list')">
              <a @click.prevent="redirect('list-claims')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-shield-alert"></i>
                  <span class="sidebar-subitem-title">Sinistros</span>
                </div>
              </a>
            </li>
            <li v-if="$can('endorsement-list')">
              <a @click.prevent="redirect('list-endorsement')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-thumb-up"></i>
                  <span class="sidebar-subitem-title">Endossos</span>
                </div>
              </a>
            </li>
            <!-- Corretoras -->
            <li v-if="$can('broker-list')">
              <a @click.prevent="redirect('list-broker')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-account-tie"></i>
                  <span class="sidebar-subitem-title">Corretoras</span>
                </div>
              </a>
            </li>
            <li>
              <a @click.prevent="redirect('kanban-renewal')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-calendar-clock"></i>
                  <span class="sidebar-subitem-title">Renovações</span>
                </div>
              </a>
            </li>
            <li>
              <a @click.prevent="redirect('list-billets')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-barcode-scan"></i>
                  <span class="sidebar-subitem-title">Boletos</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <!-- Relatórios -->
      <li v-if="accessReports()">
        <a @click.prevent="redirect('list-reports')" class="sidebar-item">
          <div class="sidebar-item-label">
            <i class="mdi sidebar-item-icon mdi-file-chart"></i>
            <span class="sidebar-item-title">Exportação Quiver</span>
          </div>
        </a>
      </li>

      <!-- Administração -->
      <li>
        <div class="sidebar-item has-subitems" :class="{ active: isAdmActive }">
          <div class="sidebar-item-label" @click.stop="toggleAdministration">
            <i class="mdi sidebar-item-icon mdi-cog"></i>
            <span class="sidebar-item-title">Administração</span>
          </div>
          <ul v-if="isAdmActive" class="sidebar-subitems">
            <li v-if="isMaster() || isCommercial()">
              <a @click.prevent="redirect('hubspot-search')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-hubspot"></i>
                  <span class="sidebar-subitem-title">Buscar Hubspot</span>
                </div>
              </a>
            </li>
            <li v-if="isClientHolder()">
              <a @click="redirect('my-limits-list')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-chart-bar sidebar-text-color"></i>
                  <span class="sidebar-subitem-title">Meus limites</span>
                </div>
              </a>
            </li>
            <li v-if="$can('certificate-list')">
              <a @click.prevent="redirect('certificate-list')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-file-document-multiple"></i>
                  <span class="sidebar-subitem-title">Certidões</span>
                </div>
              </a>
            </li>
            <!-- <li v-if="$can('broker-list')">
              <a @click.prevent="redirect('appointment-letter')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-email-open-multiple"></i>
                  <span class="sidebar-subitem-title">Carta de Nomeação</span>
                </div>
              </a>
            </li> -->
            <li v-if="$can('process-list')">
              <a @click.prevent="redirect('list-jurimetry')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-gavel"></i>
                  <span class="sidebar-subitem-title">Apoio Jurídico</span>
                </div>
              </a>
            </li>
            <li v-if="$can('user-list') && isMaster()">
              <a @click.prevent="redirect('list-client')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-handshake"></i>
                  <span class="sidebar-subitem-title">Área do Tomador</span>
                </div>
              </a>
            </li>
            <li v-if="$can('integration-list')">
              <a @click.prevent="redirect('list-integrations')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-link-variant"></i>
                  <span class="sidebar-subitem-title">Integrações</span>
                </div>
              </a>
            </li>
            <li v-if="$can('user-list')">
              <a @click.prevent="redirect('list-users')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-account-multiple"></i>
                  <span class="sidebar-subitem-title">Usuários</span>
                </div>
              </a>
            </li>
            <li v-if="isMaster()">
              <a @click.prevent="redirect('list-permissions')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-lock"></i>
                  <span class="sidebar-subitem-title">Permissões</span>
                </div>
              </a>
            </li>
            <li v-if="isMaster()">
              <a @click.prevent="redirect('list-commission')" class="sidebar-subitem">
                <div class="sidebar-subitem-label">
                  <i class="mdi sidebar-item-icon mdi-currency-usd"></i>
                  <span class="sidebar-subitem-title">Comissão</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </li>

    </ul>
  </nav>
</template>

<script>
import authenticationService from "@/services/authentication";
export default {
  name: "Sidebar",
  data() {
    return {
      isQuotationsActive: true,
      isPoliciesActive: true,
      isAdmActive: false,
    };
  },
  methods: {
    redirect(routeName) {
      this.$router.push({ name: routeName });
    },
    toggleQuotations() {
      this.isQuotationsActive = !this.isQuotationsActive;
    },
    togglePolicies() {
      this.isPoliciesActive = !this.isPoliciesActive;
    },
    toggleAdministration() {
      this.isAdmActive = !this.isAdmActive;
    },
    isMaster() {
      return authenticationService.isMaster();
    },
    isCommercial() {
      return authenticationService.isCommercial();
    },
    isClientHolder() {
      return authenticationService.isClientHolder();
    },
    accessReports() {
      return authenticationService.accessReports();
    },
  },
};
</script>

<style>
</style>
